import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
    Card,
    CardBody,
    Container
} from "reactstrap";
import {
    DropdownToggle, DropdownMenu,
    Nav, NavItem, NavLink,
    UncontrolledButtonDropdown,
    DropdownItem
} from 'reactstrap';
import cx from "classnames"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import GridLayout from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import { Col, Row } from "react-bootstrap";
import './assets/css/dashboard.css';
import Skeleton from '@mui/material/Skeleton';
import requestApi from "../../services/requestApi.service";
import { randstr } from '../../Common/Appcommon';
import { previousList } from './Constants';
const PrimaryDashboard = (props) => {
    let { selectedDashboard, isNeedRefresh, editChartConfig, cloneChartConfig, deletePrimaryChart, user, isDraggable, updateLayoutData, layoutInfo, isCanceled, resetLayoutCancel } = props;
    let refreshValue = isNeedRefresh;
    const [primaryDashboardData, setPrimaryDashboardData] = useState(selectedDashboard);
    const [primaryDashboardContent, setPrimaryDashboardContent] = useState({});
    let [layoutData, setLayoutData] = useState([]);
    let [initialLayoutData, setInitialLayoutData] = useState([]);
    let [layoutNameKey, setLayoutNameKey] = useState({});
    useEffect(() => {
        (async () => {
            if (selectedDashboard.length > 0) {
                loadPrimaryDashboardContent();
            }
        })();
        return () => {
        };
    }, [selectedDashboard]);

    useEffect(() => {
        if (isNeedRefresh !== "") {
            loadPrimaryDashboardContent();
        }
    }, [isNeedRefresh]);

    useEffect(() => {
        if (isCanceled) {
            setLayoutData(initialLayoutData); 
            updateLayoutData(initialLayoutData);
            resetLayoutCancel();
        }
    }, [isCanceled]);

    const constructLayoutData = async (pdInfo) => {
        let layout = [];
        let keymap = {};
        if (layoutInfo === "" || layoutInfo === "null" || layoutInfo === undefined || layoutInfo === null) {
            let indexvalue = 0;
            let rowvalue = 0;
            pdInfo.map((data, index) => {
                let name = data[0];
                let did = data[6];
                let xvalue = indexvalue * 2;
                if (xvalue > 10) {
                    xvalue = 0;
                    indexvalue = 0;
                    rowvalue = rowvalue + 1;
                }
                indexvalue = indexvalue + 1;
                let key = randstr("pri_") + "##" + name + "_" + did;
                key = key.replaceAll(" ", "_");
                keymap[name + "_" + did] = key;
                let tmplayout = { i: key, x: xvalue, y: rowvalue, w: 2, h: .83, isResizable: false };
                layout.push(tmplayout);
            });
        } else {
            //layoutInfo = JSON.parse(layoutInfo);
            if (layoutInfo.length > 0) {
                layoutInfo.map((data, index) => {
                    let ddata = pdInfo[index];
                    if (Array.isArray(ddata)) {
                        let layoutkey = data['i'];
                        let name = ddata[0];
                        let did = ddata[6];
                        if (layoutkey !== undefined && name !== undefined && did !== undefined) {
                            keymap[name+"_"+did] = layoutkey;
                        }
                    }
                });
                layout = layoutInfo;
            }
        }
        setLayoutNameKey(keymap);
        setLayoutData(layout);
        setInitialLayoutData(layout);
        updateLayoutData(layout);
    }

    const loadPrimaryDashboardContent = async () => {
        let dashboardData = selectedDashboard[0];
        let dList = dashboardData[2];
        let dData = dashboardData;
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "FETCH_HEADER_DASHBOARD_DETAILS",
            "FORMNAME": dashboardData[0],
            "tempdetails": dList,
            "needRefreshed": isNeedRefresh !== "",
            "isSearchNeeded": Object.keys(user).length > 0 ? true : false,
            "SEARCHUSER": Object.keys(user).length ? user.label : "All Users",
        }
        let res = await requestApi.processServerRequest(params);
        if (res.issuccess) {
            let data = res.data;
            let dashboardContent = {};
            data.map((item, index) => {
                dashboardContent[item[0] + "_" + index] = item;
            });
            await constructLayoutData(dList);
            setPrimaryDashboardContent(dashboardContent);
            setPrimaryDashboardData(selectedDashboard);
        }
    }

    const handleClick = (e, formname, chartId) => {
        if (!isDraggable) {
            openFormData(e, formname, chartId);
        }
    };

    const handleLayoutChange = async (layout) => {
        setLayoutData(layout);
        updateLayoutData(layout);
    }

    const openFormData = async (e, formname, primaryChartId) => {
        e.preventDefault();
        window.open(
            "#/crmsearch",
            '_self' // <- This is what makes it open in a new window.
        );
        let timeout = 3000;
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "FETCH_NEW_PRIMARY_DB_DETAILS",
            "chartId": primaryChartId,
            "ISREARRAGE": true
        }
        let res = await requestApi.processServerRequest(params);
        if (res.issuccess) {
            let ddata = res.data;
            if (ddata.length > 0) {
                let condition = ddata[0]['data_condition'];
                setTimeout(() => {
                    let iframe = document.getElementById('cloned_iframe');
                    if (iframe != null) {                        
                        condition = condition.replaceAll("|", "empty");
                        let msgData = "primarydashboardsearch|" + formname + "|" + condition;
                        iframe.contentWindow.postMessage(msgData, "*");

                    }
                }, timeout);
            }
        }
    }
    return (
        <div className='primary-dashboard-container'>
            <div className='ml-1 mr-1'>
                {
                    primaryDashboardData.length > 0 && (() => {
                        let dashboardData = primaryDashboardData[0];
                        let pdInfo = dashboardData[2];
                        return (
                            <Row className=''>
                                <GridLayout
                                    className="layout"
                                    layout={layoutData}
                                    cols={12}
                                    width={1200}
                                    onLayoutChange={handleLayoutChange}
                                    isDraggable={isDraggable}
                                >
                                    {pdInfo.map((item, index) => {
                                        let condition = item[4];
                                        let chartType = item[5];
                                        let chartId = item[6];
                                        let formname = item[7];
                                        let primaryData = primaryDashboardContent[item[0] + "_" + index];
                                        let comparisonData = item[8];
                                        let name = "";
                                        let count = "";
                                        let valuesum = "";
                                        let divStyle = {};
                                        let dbcolor = "";
                                        let cData = {};
                                        let compareValue = [];
                                        let isComparePositive = false;
                                        let arrowClass = "";
                                        let periodStr = "";
                                        if (primaryData !== undefined) {
                                            name = primaryData[0];
                                            count = primaryData[1];
                                            dbcolor = primaryData[2];
                                            valuesum = primaryData[3];
                                            if (chartType === "comparison") {
                                                compareValue = primaryData[4];
                                                if (comparisonData !== "" && comparisonData !== null) {
                                                    cData = JSON.parse(comparisonData);
                                                    if (cData['objective'] !== undefined && cData['objective']['value'] !== undefined) {
                                                        if (cData['objective']['value'] === "positive") {
                                                            isComparePositive = true;
                                                        }
                                                    }
                                                    if (cData['duration_type'] !== undefined && cData['duration_type']['value'] !== undefined) {
                                                        let durationType = cData['duration_type']['value'];
                                                        if (durationType !== "Last" && durationType !== "Custom") {
                                                            periodStr = previousList[durationType]
                                                        } else {
                                                            periodStr = compareValue[2];
                                                        }
                                                    }
                                                }
                                                if (compareValue !== undefined && compareValue.length > 0) {
                                                    if (isComparePositive && compareValue[1] > 0) {
                                                        arrowClass = "arrow-up-big"
                                                    } else if (isComparePositive && compareValue[1] < 0) {
                                                        arrowClass = "arrow-down-big";
                                                    } else if (!isComparePositive && compareValue[1] < 0) {
                                                        arrowClass = "arrow-up-big";
                                                    } else if (!isComparePositive && compareValue[1] > 0) {
                                                        arrowClass = "arrow-down-big";
                                                    }
                                                }
                                            }
                                            if (dbcolor !== "" && dbcolor !== null && !dbcolor.startsWith("#")) {
                                                dbcolor = `#${dbcolor}`;
                                            }
                                            if (dbcolor !== "" && dbcolor !== null && dbcolor.toLowerCase() !== "#ffffff") {
                                                divStyle = {
                                                    backgroundColor: dbcolor,
                                                    color: "#FFFFFF",
                                                    fontWeight: "bold"
                                                };
                                            } else {
                                                divStyle = {
                                                    backgroundColor: "#FFFFFF",
                                                    color: "#000000",
                                                    fontWeight: "bold"
                                                };
                                            }
                                        }
                                        let layoutKey = layoutNameKey[name + "_" + chartId];
                                        return (
                                            <div key={layoutKey} md="2" className={`mb-1 grid-item ${name}`}>
                                                <Card className="main-card border pri-dashboard-card" style={divStyle}>
                                                    <CardBody>
                                                        <Fragment>
                                                            <UncontrolledButtonDropdown className='primary-dashboard-component'>
                                                                <DropdownToggle color="link" className="p-0" >
                                                                    <div className='cursor-pointer pd-more-settings'>
                                                                        <span className='pd-chart-settings'>
                                                                            <FontAwesomeIcon className='fa-icon' icon={faEllipsisVertical} />
                                                                        </span>
                                                                    </div>
                                                                </DropdownToggle>
                                                                <DropdownMenu end className="rm-pointers dropdown-menu-md">
                                                                    <DropdownItem key={randstr("view_")} onClick={(e) => { handleClick(e, formname, chartId) }} >
                                                                        <span className='ml-1'>View</span>
                                                                    </DropdownItem>
                                                                    <DropdownItem key={randstr("edit_")} onClick={(e) => { editChartConfig(e, chartId, chartType) }} >
                                                                        <span className='ml-1'>Edit</span>
                                                                    </DropdownItem>
                                                                    <DropdownItem key={randstr("clone_")} onClick={(e) => { cloneChartConfig(e, chartId, chartType) }} >
                                                                        <span className='ml-1'>Clone</span>
                                                                    </DropdownItem>
                                                                    <DropdownItem key={randstr("delete_")} onClick={(e) => { deletePrimaryChart(e, chartId) }}>
                                                                        <span className='ml-1'>Delete</span>
                                                                    </DropdownItem>
                                                                </DropdownMenu>
                                                            </UncontrolledButtonDropdown>
                                                        </Fragment>
                                                        <div className='text-center' >
                                                            <span className='primary-name-content'>{name}</span>

                                                            {
                                                                primaryData === undefined &&
                                                                <Skeleton animation="wave" />
                                                            }
                                                            {
                                                                primaryData !== undefined &&
                                                                <div className='d-flex-alone f-column'>
                                                                    {
                                                                        valuesum !== undefined && valuesum !== "-NA-" ?
                                                                            <>
                                                                                <span className='primary-data'>
                                                                                    {valuesum}
                                                                                    {chartType === "comparison" && compareValue !== undefined && compareValue.length > 0 &&
                                                                                        <span className={cx('comparison-data ' + arrowClass)} >
                                                                                            <span className={" comparison-symbol comparison-triangle"}></span>
                                                                                            <span>{compareValue[1] < 0 ? compareValue[1] * -1 : compareValue[1]}%</span>
                                                                                        </span>
                                                                                    }

                                                                                </span>
                                                                                {chartType === "comparison" && compareValue !== undefined && compareValue.length > 0 &&
                                                                                    <span className='comparison-value'>{periodStr}: {compareValue[0]}</span>
                                                                                }
                                                                                {chartType !== "comparison" &&
                                                                                    <span>{count} records</span>
                                                                                }
                                                                            </> :
                                                                            <>
                                                                                <span className='primary-data'>
                                                                                    {count}
                                                                                    {chartType === "comparison" && compareValue.length > 0 &&
                                                                                        <span className={cx('comparison-data ' + arrowClass)} >
                                                                                            <span className={" comparison-symbol comparison-triangle"}></span>
                                                                                            <span>{compareValue[1] < 0 ? compareValue[1] * -1 : compareValue[1]}%</span>
                                                                                        </span>
                                                                                    }
                                                                                </span>
                                                                                {chartType === "comparison" && compareValue.length > 0 &&
                                                                                    <span className='comparison-value'>{periodStr}: {compareValue[0]}</span>
                                                                                }
                                                                                {chartType !== "comparison" &&
                                                                                    <span className='secondary-data'>records</span>
                                                                                }
                                                                            </>
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        )
                                    })}
                                </GridLayout>
                            </Row>
                        );
                    })()
                }
                
            </div>
        </div >
    )
}

export default PrimaryDashboard;